import { apiDeleteV2, apiGetV2, apiPatchV2, apiPostV2 } from "~/shared/api/client";

import type {
    Element,
    ElementCreateInput,
    ElementDeleteInput,
    ElementListResponse,
    ElementUpdateInput,
} from "./types";

/**
 * Библиотека элементов workspace (`GET /v2/elements`). Бэк отдаёт весь список без
 * пагинации/фильтров — поиск, фильтрация и страницы считаются на клиенте
 * (`element-filter-utils`). `workspace_id` уходит заголовком `X-Workspace-Id`.
 */
export function listElements(workspaceId: string): Promise<ElementListResponse> {
    return apiGetV2<ElementListResponse>("/elements", undefined, { workspaceId });
}

export function createElement({ workspaceId, ...body }: ElementCreateInput): Promise<Element> {
    return apiPostV2<Element>("/elements", body, { workspaceId });
}

export function updateElement({ workspaceId, elementId, ...body }: ElementUpdateInput): Promise<Element> {
    return apiPatchV2<Element>(`/elements/${elementId}`, body, { workspaceId });
}

export function deleteElement({ workspaceId, elementId }: ElementDeleteInput): Promise<void> {
    return apiDeleteV2<void>(`/elements/${elementId}`, undefined, { workspaceId });
}
